var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
function useLoadAvatar(src) {
    var _a = __read(React.useState(false), 2), loaded = _a[0], setLoaded = _a[1];
    var _b = __read(React.useState(""), 2), imageSrc = _b[0], setImage = _b[1];
    var _c = __read(React.useState(false), 2), error = _c[0], setError = _c[1];
    React.useEffect(function () {
        var handleError = function () {
            setError(true);
            setLoaded(true);
        };
        var handleLoad = function () {
            setError(false);
            setLoaded(true);
        };
        var img = new Image();
        img.onerror = handleError;
        img.onload = handleLoad;
        img.src = src;
        setImage(src);
        // Clear out old handlers if src is changed while loading
        return function () {
            img.onerror = null;
            img.onload = null;
        };
    }, [src]);
    return {
        loaded: loaded,
        imageSrc: imageSrc,
        error: error
    };
}
export default useLoadAvatar;
//# sourceMappingURL=useLoadAvatar.js.map